module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-59.eb09537.woff2";